"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
class ReactAdsense extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
    }
    componentDidMount() {
        this.handleUpdate();
    }
    componentDidUpdate() {
        this.handleUpdate();
    }
    handleUpdate() {
        const p = {};
        if (this.props.pageLevelAds) {
            p.google_ad_client = this.props.client;
            p.enable_page_level_ads = true;
        }
        if (typeof window !== 'undefined') {
            // not SSR
            try {
                (window.adsbygoogle || []).push(p);
            }
            catch (_a) {
                // Just ignore the error
            }
        }
    }
    render() {
        const _a = this.props, { className, style, client, slot, layout, layoutKey, format, responsive, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        pageLevelAds, adTest, children } = _a, rest = __rest(_a, ["className", "style", "client", "slot", "layout", "layoutKey", "format", "responsive", "pageLevelAds", "adTest", "children"]);
        return (react_1.default.createElement("ins", Object.assign({ className: `adsbygoogle ${className !== null && className !== void 0 ? className : ''}`, style: style, "data-ad-client": client, "data-ad-slot": slot, "data-ad-format": format, "data-ad-layout": layout, "data-ad-layout-key": layoutKey, "data-full-width-responsive": responsive, "data-adtest": adTest }, rest), children));
    }
}
exports.default = ReactAdsense;
ReactAdsense.defaultProps = {
    className: '',
    style: { display: 'block' },
    client: undefined,
    slot: undefined,
    layout: '',
    layoutKey: '',
    format: 'auto',
    responsive: 'false',
    pageLevelAds: false,
    adTest: undefined,
    children: undefined,
};
